import { Typography, Chip, Box, alpha, useTheme } from '@mui/material';
import { motion } from 'framer-motion';

import CustomCard from '../../components/CustomCard';
import { FRONTEND_SKILLS, BACKEND_SKILLS, OTHER_SKILLS } from '../../constants/skills';
import skillsIcon from '../../assets/icons/skills.png';
import SkillsDialog from '../../components/SkillsDialog';
import { useState } from 'react';
import useVisibilityOnScroll from '../../hooks/useVisibilityOnScroll';

const MotionChip = motion(Chip);
const MotionBox = motion(Box);

const Skills = () => {
  const [isSkillsDialogOpen, setIsSkillsDialogOpen] = useState<boolean>(false)
  const [frontendSkillsRef, isFrontendSkillsVisible] = useVisibilityOnScroll(0.3);
  const [backendSkillsRef, isBackendSkillsVisible] = useVisibilityOnScroll(0.3);
  const [otherSkillsRef, isotherSkillsVisible] = useVisibilityOnScroll(0.3);
  const theme = useTheme();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
      }
    }
  };

  const chipVariants = {
    hidden: { opacity: 0, scale: 0.8, y: 20 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: [0.4, 0, 0.2, 1] as any
      }
    }
  };

  return (
    <>
      <CustomCard title="Skills" titleIcon={skillsIcon} link="View Breakdown" handleLinkClick={() => setIsSkillsDialogOpen(!isSkillsDialogOpen)}>
        <MotionBox
          ref={frontendSkillsRef}
          variants={containerVariants}
          initial="hidden"
          animate={isFrontendSkillsVisible ? "visible" : "hidden"}
          sx={{ mb: 3 }}
        >
          <Typography
            variant='h6'
            sx={{
              mb: 1.5,
              fontWeight: 600,
              color: 'text.primary',
            }}
          >
            Frontend
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {FRONTEND_SKILLS.map((skill) => (
              <MotionChip
                // avatar={<Avatar alt={`${skill.name} Icon`} src={skill.image} sx={{ width: 20, height: 20 }} />}
                key={skill.name}
                label={skill.name}
                variants={chipVariants}
                whileHover={{ scale: 1.05, y: -2 }}
                sx={{
                  fontSize: "13px",
                  fontWeight: 500,
                  backgroundColor: alpha(theme.palette.background.paper, 0.8),
                  backdropFilter: 'blur(10px)',
                }}
              />
            ))}
          </Box>
        </MotionBox>

        <MotionBox
          ref={backendSkillsRef}
          variants={containerVariants}
          initial="hidden"
          animate={isBackendSkillsVisible ? "visible" : "hidden"}
          sx={{ mb: 3 }}
        >
          <Typography
            variant='h6'
            sx={{
              mb: 1.5,
              fontWeight: 600,
              color: 'text.primary',
            }}
          >
            Backend
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {BACKEND_SKILLS.map((skill) => (
              <MotionChip
                // avatar={<Avatar alt={`${skill.name} Icon`} src={skill.image} sx={{ width: 20, height: 20 }} />}
                key={skill.name}
                label={skill.name}
                variants={chipVariants}
                whileHover={{ scale: 1.05, y: -2 }}
                sx={{
                  fontSize: "13px",
                  fontWeight: 500,
                  backgroundColor: alpha(theme.palette.background.paper, 0.8),
                  backdropFilter: 'blur(10px)',
                }}
              />
            ))}
          </Box>
        </MotionBox>

        <MotionBox
          ref={otherSkillsRef}
          variants={containerVariants}
          initial="hidden"
          animate={isotherSkillsVisible ? "visible" : "hidden"}
        >
          <Typography
            variant='h6'
            sx={{
              mb: 1.5,
              fontWeight: 600,
              color: 'text.primary',
            }}
          >
            Cloud & Other Developer Tools
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {OTHER_SKILLS.map((skill) => (
              <MotionChip
                // avatar={<Avatar alt={`${skill.name} Icon`} src={skill.image} sx={{ width: 20, height: 20 }} />}
                key={skill.name}
                label={skill.name}
                variants={chipVariants}
                whileHover={{ scale: 1.05, y: -2 }}
                sx={{
                  fontSize: "13px",
                  fontWeight: 500,
                  backgroundColor: alpha(theme.palette.background.paper, 0.8),
                  backdropFilter: 'blur(10px)',
                }}
              />
            ))}
          </Box>
        </MotionBox>
      </CustomCard>
      <SkillsDialog open={isSkillsDialogOpen} handleClose={() => setIsSkillsDialogOpen(!isSkillsDialogOpen)} />
    </>
  )
}

export default Skills;